import { SEASONS, SEASON_PALETTES, type Season } from "../hooks/use-seasonal-theme";

export const INITIAL_SEASON_META = "enkey-site-season";
export function resolveSeason(value: unknown): Season {
  return typeof value === "string" && (SEASONS as readonly string[]).includes(value) ? value as Season : "none";
}
export function readInitialSeason(): Season {
  return typeof document === "undefined" ? "none" : resolveSeason(document.querySelector<HTMLMetaElement>(`meta[name="${INITIAL_SEASON_META}"]`)?.content);
}
export function browserThemeColor(season: Season, mode: "light" | "dark"): string {
  const color = season === "none" ? (mode === "dark" ? "oklch(0.65 0.18 256)" : "oklch(0.55 0.183 256)") : SEASON_PALETTES[season][mode]["--primary"];
  const [lightness, chroma, hue] = color.match(/[\d.]+/g)!.map(Number);
  const angle = hue * Math.PI / 180, a = chroma * Math.cos(angle), b = chroma * Math.sin(angle);
  const l = (lightness + .3963377774*a + .2158037573*b)**3;
  const m = (lightness - .1055613458*a - .0638541728*b)**3;
  const s = (lightness - .0894841775*a - 1.291485548*b)**3;
  const channels = [4.0767416621*l-3.3077115913*m+.2309699292*s, -1.2684380046*l+2.6097574011*m-.3413193965*s, -.0041960863*l-.7034186147*m+1.707614701*s];
  return "#" + channels.map(value => {
    const v = Math.max(0, Math.min(1, value));
    return Math.round((v <= .0031308 ? 12.92*v : 1.055*v**(1/2.4)-.055)*255).toString(16).padStart(2,"0");
  }).join("");
}
